export default "__VITE_ASSET__BFQ7OPh6__"